import { render, staticRenderFns } from "./messageSent.vue?vue&type=template&id=58e6fe5f"
import script from "./messageSent.vue?vue&type=script&lang=js"
export * from "./messageSent.vue?vue&type=script&lang=js"
import style0 from "./messageSent.vue?vue&type=style&index=0&id=58e6fe5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports